/**
* Utility function to handle HubSpot API errors consistently across all components
* @param {Error} error - The error object from axios/fetch
* @returns {string} - User-friendly error message
*/
export const handleHubSpotError = (error) => {
    console.error("HubSpot API error:", error);
    let errorMessage = "Something went wrong. Please try again.";
    if (error.response) {
      // Server responded with error status
      if (error.response.status === 429) {
        errorMessage = "Too many requests. Please try again later.";
      } else if (error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.response.data && error.response.data.errors && error.response.data.errors[0]?.message) {
        // Handle HubSpot specific error format
        const [, specificMessage] = error.response.data.errors[0].message.split(". ") || ["", ""];
        errorMessage = specificMessage || error.response.data.errors[0].message;
      } else if (error.response.statusText) {
        errorMessage = `Error ${error.response.status}: ${error.response.statusText}`;
      } else if (error.response.status) {
        errorMessage = `Error ${error.response.status}`;
      }
    } else if (error.request) {
      // Request was made but no response received
      errorMessage = "Network error. Please check your connection.";
    } else if (error.message) {
      // Something else happened
      errorMessage = error.message;
    }
    return errorMessage;
  };